import * as React from 'react';
import classnames from 'classnames';
import { isTouchDevice } from '../../Util/is-touch-device.js';
import '@swc/helpers';
import 'lodash/uniq';
import '@grandvisionhq/utils';
import '../../MediaQuery/MediaQueryContext.js';
import '../../Util/get-donation-foundation-icon.js';
import { TooltipProvider } from './TooltipContext.js';

const TooltipContainer = ({ className , theme , children ,  })=>{
    const [isActive, setIsActive] = React.useState(false);
    const isTouch = React.useMemo(isTouchDevice, []);
    const tooltipClass = classnames('tooltip', className, {
        'tooltip--black': theme === 'black',
        'tooltip--grey': theme === 'grey',
        'tooltip--white': theme === 'white'
    });
    return /*#__PURE__*/ React.createElement(TooltipProvider, {
        value: {
            isActive,
            setIsActive,
            isTouch
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: tooltipClass,
        "data-t": "tooltip"
    }, children));
};

export { TooltipContainer };
//# sourceMappingURL=TooltipContainer.js.map
